<template>
	<ion-button size="small" color="transparent" :style="`background: ${statusMap[status]?.background}; color: ${statusMap[status]?.color}`">
		<ion-icon class="-ml-2 mr-2" :src="statusMap[status]?.icon" />
		<span class="pt-[2px] uppercase font-bold text-[11px] tracking-widest">{{ statusMap[status]?.name }}</span>
	</ion-button>
</template>

<script>
export default {
	props: {
		status: {
			type: String,
			required: true
		},

		statusMap: {
			type: Object,
			required: true
		}
	}
}

</script>

<style lang="sass" scoped>
ion-button
	width: fit-content
	height: 31px
	border-radius: 0.25rem
	padding-left: 5px
	padding-right: 0px
	margin: 0
	pointer-events: none
</style>